import React from "react";
import certifIcon from "../../assets/img/aboutUs/content.png";
import surMesureIcon from "../../assets/img/aboutUs/mortarboard.png";
import deviseIcon from "../../assets/img/aboutUs/skill-development.png";

const AboutUs = () => {
  return (
    <section className="about-section" id="about">
      {/* Partie droite : texte mission */}
      <article className="about-mission">
        <h2 className="about-mission-title">
          4 CERVEAUX.
          <br /> 4 <strong>VIBES</strong>.<br /> <strong>UNE</strong> MISSION :
          <br />
          ÉLEVER LES <strong>COMPÉTENCES</strong>.
        </h2>
        <p className="about-mission-text">
          UP4MIND, C’EST L’UNION DE QUATRE PROFESSIONNELS ISSUS D’UNIVERS VARIÉS
          :<br />
          <br />
          COMMUNICATION 360°, DIGITAL, ACCOMPAGNEMENT HUMAIN ET EXCELLENCE
          TERRAIN.
          <br />
          <br />
          NOUS AVONS DÉCIDÉ DE CRÉER UN ORGANISME DE FORMATION À TAILLE HUMAINE,
          PORTÉ PAR DES VALEURS FORTES :<br />
          <br />– ACCESSIBILITÉ, ADAPTABILITÉ, PÉDAGOGIE <br />– ACTIVE ET
          QUALITÉ CERTIFIÉE.
        </p>
      </article>

      {/* Partie gauche : les cartes colorées */}
      <aside className="about-cards">
        <div className="about-card border-yellow">
          <div className="about-icon">
            <img src={certifIcon} alt="Certification" />
          </div>
          <p className="about-card-text">
            {/* <strong>CERTIFIÉS QUALIOPI</strong>
            <br />
            (DONC VOUS POUVEZ VOUS FAIRE FINANCER) */}
            Modules à la carte & planning modulable selon vos disponibilités
          </p>
        </div>
        <div className="about-card border-pink">
          <div className="about-icon">
            <img src={surMesureIcon} alt="Sur mesure" />
          </div>
          <p className="about-card-text">
            SUR MESURE POUR VOUS, VOTRE BOÎTE,
            <br />
            OU VOTRE ÉQUIPE DE CHOC
          </p>
        </div>
        <div className="about-card border-blue">
          <div className="about-icon">
            <img src={deviseIcon} alt="Devise" />
          </div>
          <p className="about-card-text">
            <em>NOTRE DEVISE ?</em>
            <br />
            APPRENDS. CONSTRUIS. CRÉE. TRANSMETS.
            <br />
            (ET RIGOLE UN PEU EN CHEMIN, TANT QU’À FAIRE.)
          </p>
        </div>
      </aside>

      {/* Vision en bas, sur toute la largeur */}
      <article className="about-vision">
        <h2 className="about-vision-title">NOTRE VISION</h2>
        <ul className="about-vision-list">
          <li>
            - PROPOSER DES FORMATIONS UTILES ET ADAPTÉES AU MONDE PROFESSIONNEL
            D’AUJOURD’HUI
          </li>
          <li>
            - METTRE L’ACCENT SUR LA PRATIQUE, L’INTERACTIVITÉ ET L’EXPÉRIENCE
          </li>
          <li>
            - ACCOMPAGNER CHAQUE PARTICIPANT AVEC BIENVEILLANCE ET EXIGENCE
          </li>
        </ul>
      </article>
    </section>
  );
};

export default AboutUs;
